import React from "react";

import SearchBackendProvider from "../components/SearchBackendProvider";

export default function PageWrapper({ children, pluginOptions }) {
  const { backend } = pluginOptions;
  return (
    <SearchBackendProvider settings={backend}>{children}</SearchBackendProvider>
  );
}
